import React from 'react'

const ImageWithFallback = ({
  fileName,
  dir,
  type = 'image/webp',
  className,
  id,
  ...delegated
}) => {
  let directory = dir ? `${dir}/` : '/' // relative to src/images
  return (
    <picture className={className} id={id}>
      <source srcSet={require(`../images${directory}${fileName}.webp`)} type={type} />
      <img src={require(`../images${directory}${fileName}.png`)} {...delegated} className={className} id={id} />
    </picture>
  )
}

export default ImageWithFallback